export default __webpack_public_path__ + "static/media/Help.6df11b8a.svg";